import * as React from 'react';

import GradeOptions from './grade_options';

import { DropdownInput } from '../../../Shared/index';
import { DropdownObjectInterface } from '../../../Staff/interfaces/evidenceInterfaces';
import { requestPut } from '../../../../modules/request/index';
import useModalAccessibility from '../../../Shared/hooks/useModalAccessibility';
import DemoGuardedButton from '../shared/demoGuardedButton';

interface ChangeGradeModalProps {
  close: () => void;
  onSuccess: (string) => void;
  classroom: any;
}

export const ChangeGradeModal = ({ close, onSuccess, classroom }: ChangeGradeModalProps) => {
  const { modalRef } = useModalAccessibility(close);

  const [grade, setGrade] = React.useState<DropdownObjectInterface>(GradeOptions.find(grade => [Number(classroom.grade), classroom.grade].includes(grade.value)))
  const [errors, setErrors] = React.useState<{ [key: string]: string }>({})
  const [timesSubmitted, setTimesSubmitted] = React.useState<number>(0)

  function handleGradeChange(grade) {
    setGrade(grade)
  }

  function changeGrade() {
    const { id } = classroom
    requestPut(`/teachers/classrooms/${id}`, { grade: grade.value }, (body) => {
      if (body && body.errors) {
        setErrors(body.errors)
        setTimesSubmitted(timesSubmitted + 1)
      } else {
        onSuccess('Grade changed')
        close()
      }
    })
  }

  function submitButtonClass() {
    let buttonClass = 'quill-button contained medium green focus-on-light';
    if (grade && classroom.grade === grade.value) {
      buttonClass += ' disabled';
    }
    return buttonClass;
  }

  return (
    <div className="modal-container change-grade-modal-container">
      <div className="modal-background" />
      <div
        aria-labelledby="changeGradeModalTitle"
        aria-modal="true"
        className="change-grade-modal quill-modal modal-body"
        ref={modalRef}
        role="dialog"
        tabIndex={-1}
      >
        <div>
          <h3 className="title" id="changeGradeModalTitle">Change your grade level</h3>
        </div>
        <p>Update the grade level for {classroom.name}.</p>
        <DropdownInput
          className="bordered large grade focus-on-light"
          error={errors.grade}
          handleChange={handleGradeChange}
          helperText="This will not limit the activities you can access."
          label="Grade"
          options={GradeOptions}
          value={grade}
        />
        <div className="form-buttons">
          <button className="quill-button outlined green medium focus-on-light" onClick={close} type="button">Cancel</button>
          <DemoGuardedButton className={submitButtonClass()} onClick={changeGrade}>Save</DemoGuardedButton>
        </div>
      </div>
    </div>
  )
}

export default ChangeGradeModal
